export default __webpack_public_path__ + "static/media/yau.4140d837.png";